import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useConsumption } from "@/context/ConsumptionContext";

type UnitType = "kWh" | "Euro";

export const UnitToggle = () => {
	const { unit, setUnit } = useConsumption();

	return (
		<Tabs
			className="w-full"
			value={unit}
			onValueChange={(value) => setUnit(value as UnitType)}
		>
			<TabsList className="grid w-full grid-cols-2 mb-4">
				<TabsTrigger value="kWh">kWh</TabsTrigger>
				<TabsTrigger value="Euro">Euro</TabsTrigger>
			</TabsList>
		</Tabs>
	);
};
